import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { ILandingPartnerFromSearch } from 'partner360/models/landing/ILandingPartnerFromSearch'
import { ILandingPlanning } from 'partner360/models/landing/ILandingPlanning'
import { ILandingProcessedPlanningFetched } from 'partner360/models/landing/ILandingProcessedPlanningFetched'
import { LandingCategory } from 'partner360/models/landing/LandingCategory'
import { LandingOffering } from 'partner360/models/landing/LandingOffering'
import { LandingStatus } from 'partner360/models/landing/LandingStatus'

export const mapLandingPartnerFromSearchToLandingProcesses = (
  partner: ILandingPartnerFromSearch,
  planning: ILandingPlanning,
  selectedCategory: LandingCategory
): ILandingProcessedPlanningFetched[] => {
  const foundCategoryData = planning.AllCategories.find((el) => el.Category === selectedCategory)
  const offeringsWithoutTotal = foundCategoryData
    ? (foundCategoryData.Offerings.map((el) => el.Offering).filter(
        (offering) => offering !== LandingOffering.Total
      ) as ProgramTypes[])
    : []

  return offeringsWithoutTotal.map((offering) => {
    return {
      offering: offering,
      category: LandingCategory.RequestPartners,
      partnerId: partner.PartnerID,
      isOfferingActive: 0,
      status: LandingStatus.NotCompleted,
      planningId: planning.PlanningId,
      actions: [],
    }
  })
}
